<template>
  <div class="popup_wrap">
    <div class="popup">
      <div class="popup_content">
        <div class="info_wrap">
          <div v-if="menuTags.length > 0" class="tags">
            <div class="tag" :class="tag.class" v-for="(tag, idx) in menuTags" :key="`${menu._id}_${idx}`">{{ tag.name }}</div>
          </div>
          <div class="name">{{ menu.name }}</div>
          <div class="status" v-if="infoText(menu)">{{ infoText(menu) }}</div>
          <div class="description">{{ menu.description }}</div>
        </div>
        <div class="option_wrap">
          <div class="scroll-area">
            <div class="option">
              <div class="option_title">
                <div class="title">{{ $tc('size') }}</div>
              </div>
              <div class="option_list">
                <div v-if="(sizesList.length === 1)">
                  <div class="option_item">
                    <div class="name">{{ sizesList[0].name }}</div>
                    <div class="price">{{ displayPrice(sizesList[0].price) }}</div>
                  </div>
                </div>
                <div v-else>
                  <div class="option_item" :class="{selected: size.isSelected}" v-for="size in sizesList" :key="size._id" @click="changeSelectedSize(size)">
                    <div class="icon radio"></div>
                    <div class="name">{{ size.name }}</div>
                    <div class="price">{{ displayPrice(size.price) }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="option" v-for="optionGroup in menuInfo.optionGroups" :key="optionGroup._id">
              <div class="option_title">
                <div class="required" v-if="optionGroup.isRequired">{{ `[${$tc('required')}]` }}</div>
                <div class="title">{{ optionGroup.name }}</div>
                <div class="limitCnt">{{ displayLimitCnt(optionGroup) }}</div>
              </div>
              <div class="option_list">
                <div class="option_item" :class="{disabled: option.isDisabled, soldout: option.isSoldOut, selected: option.isSelected, has_count: isQtyOption(optionGroup, option)}" v-for="option in optionGroup.options" :key="option._id"
                  @click="selectOption(optionGroup, option)">
                  <div v-if="option.isSoldOut" class="soldout_badge">{{ $tc('soldOut') }}</div>
                  <div v-else class="icon" :class="{radio: isRadioGroup(optionGroup), checkbox: !isRadioGroup(optionGroup)}"></div>
                  <div class="name">{{ option.name }}</div>
                  <div class="price">{{ displayOptionPrice(option.price) }}</div>
                  <div v-if="isQtyOption(optionGroup, option)" class="option_count" @click.stop>
                    <div class="minus" :class="{disabled: (option.quantity <= 0)}" @click="changeOptionQuantity(optionGroup, option, false)"></div>
                    <div class="count">{{ option.quantity }}</div>
                    <div class="plus" :class="{disabled: (option.quantity >= optionMaxQty(optionGroup, option))}" @click="changeOptionQuantity(optionGroup, option, true)"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="select_option_wrap">
          <div class="option_list_wrap">
            <div class="selected_option_title">{{ $tc('selectedOptons') }}</div>
            <div class="list_wrap">
              <div class="selected_option_list">
                <div class="selected-option-item">
                  <div class="option_name">{{ selectedOptions.size.name }}</div>
                  <div class="option_price">{{ displayPrice(selectedOptions.size.price) }}</div>
                </div>
                <div v-for="option in Array.from(selectedOptions.options.values())" :key="option._id" class="selected-option-item">
                  <div class="option_name">{{ (option.quantity > 1) ? `${option.name} (${$tc('unitCount', option.quantity)})` : option.name }}</div>
                  <div class="option_price">{{ displayOptionPrice(option.price * (option.quantity || 1)) }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="count_button_wrap">
            <div class="button_title">{{ $tc('units') }}</div>
            <div class="count_button">
              <div class="minus" :class="{disabled: (selectedQuantity === 1)}" @click="changeQuantity(false)"></div>
              <div class="count">{{ selectedQuantity }}</div>
              <div class="plus" :class="{disabled: isLimited}" @click="changeQuantity(true)"></div>
            </div>
          </div>
          <div v-show="isLimited" class="speech-bubble">
            <div v-html="$tc('remainedQuantity', this.maxQuantity)"></div>
          </div>
        </div>
      </div>
      <div class="button_wrap">
        <div class="button close_popup" @click="closePopup">{{ $tc('cancle') }}</div>
        <div class="button save_option" @click="addSelectedMenu(menu)">{{ `${$tc('textOfOptionAddButton', selectedQuantity)} ${$tc('textOfOptionAddButton_2', calcTotalPrice())}` }}</div>
      </div>
    </div>
    <alert-popup v-show="showAlert" :msg="alertMsg" @AlertEvent="() => { this.showAlert = false }" />
  </div>
</template>
<script>
import alertPopup from '@/components/AlertPopup'
export default {
  name: 'menuSelectPopup',
  components: { alertPopup },
  computed: {
    maxQuantity () {
      return (this.menuInfo.restrictionType === 'NO_LIMIT') ? this.menuInfo.leftQuantity : ((this.menuInfo.leftQuantity >= this.menuInfo.maxPermittedQuantity) ? this.menuInfo.maxPermittedQuantity : this.menuInfo.leftQuantity)
    },
    menuTags () {
      const list = []
      if (this.menuInfo.isFeatured) {
        list.push(
          { name: this.$tc('best'), class: 'featured' }
        )
      }
      if (this.menuInfo.isMain) {
        list.push(
          { name: this.$tc('main'), class: 'main' }
        )
      }
      if (this.menuInfo.restrictionType !== 'NO_LIMIT') {
        list.push(
          { name: this.$tc('limted'), class: 'limited' }
        )
      }
      return list
    }
  },
  watch: {
    menu: {
      immediate: true,
      deep: true,
      handler (val) {
        this.menuInfo = JSON.parse(JSON.stringify(val))
        this.remainMainMenuCnt = this.remainCnt
        if (this.isModifing) {
          this.sizesList = this.menuInfo.sizes.map((size) => {
            if (size.isSelected) { this.selectedOptions.size = size }
            return size
          })
          this.selectedQuantity = this.menuInfo.quantity
          if (this.menuInfo.isMain) { this.remainMainMenuCnt += this.menuInfo.quantity }
          const tempOptionGroups = this.menuInfo.optionGroups.map(group => group)
          this.optionGroupList = tempOptionGroups.map(optionGroup => {
            let selectCnt = 0
            optionGroup.options = optionGroup.options.map(option => {
              // 수정 진입 시 선택된 옵션의 수량 복원 (수량 미전달 옵션은 1개로 간주)
              option.quantity = option.isSelected ? (option.quantity || 1) : 0
              if (option.quantity > 0) {
                option.isSelected = true
                selectCnt += option.quantity
                const { _id, name, price, quantity } = option
                this.selectedOptions.options.set(_id, { name, price, _id, quantity })
              }
              return option
            })
            optionGroup.selectedCnt = selectCnt
            optionGroup.options = optionGroup.options.map(option => {
              option.isDisabled = (selectCnt >= optionGroup.selectableCount && !option.isSelected && !optionGroup.isRequired)
              return option
            })
            return optionGroup
          })
        } else {
          this.sizesList = this.menuInfo.sizes.map((size, idx) => {
            size.isSelected = (idx === 0)
            return size
          })
          this.selectedOptions.size = val.sizes[0]
          const tempOptionGroups = this.menuInfo.optionGroups.map(group => group)
          this.optionGroupList = tempOptionGroups.map((optionGroup) => {
            optionGroup.selectedCnt = 0
            let selectedIdx = -1
            const tempOptions = optionGroup.options.map((option, idx) => {
              if (!option.isSoldOut && selectedIdx === -1 && optionGroup.selectableCount === 1 && optionGroup.isRequired) {
                option.isSelected = true
                option.quantity = 1
                const { _id, name, price } = option
                this.selectedOptions.options.set(_id, { name, price, _id, quantity: 1 })
                selectedIdx = idx
                optionGroup.selectedCnt = 1
              } else {
                option.isSelected = false
                option.quantity = 0
              }
              return option
            })
            optionGroup.options = tempOptions
            return optionGroup
          })
        }
        this.isLimited = (this.selectedQuantity === this.maxQuantity)
      }
    }
  },
  props: {
    selectedMenuList: { type: Map },
    useOnePersonOneMenuOrder: { type: Boolean },
    useMenuOptionQuantity: { type: Boolean, default: false },
    remainCnt: { type: Number },
    isModifing: { type: Boolean },
    menu: { type: Object },
    outOfStockSetQuantity: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      remainMainMenuCnt: -1,
      alertMsg: '',
      showAlert: false,
      sizesList: [],
      isLimited: false,
      menuInfo: {},
      optionGroupList: [],
      selectedOptions: {
        size: {},
        options: new Map()
      },
      selectedQuantity: 1
    }
  },
  methods: {
    /**
     * @description 선택된 옵션, 사이즈 가격의 합을 반환
     * @returns {number}
     */
    calcPrice () {
      const options = Array.from(this.selectedOptions.options.values())
      const size = this.selectedOptions.size
      let optionPrice = 0
      options.forEach(option => {
        optionPrice = Number(optionPrice) + (Number(option.price) * Number(option.quantity || 1))
      })
      return Number(optionPrice + Number(size.price))
    },
    /**
     * @description 선택된 옵션, 사이즈, 수량의 가격을 반환
     * @returns {string} ex) 20,000
     */
    calcTotalPrice () {
      const totalPrice = this.calcPrice() * this.selectedQuantity
      return totalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    /**
     * @description 메뉴 수량 조절
     * @param {boolean} isPlus
     * @returns {void}
     */
    changeQuantity (isPlus) {
      if (isPlus) {
        if (this.isLimited) { return }
        if (this.maxQuantity > this.selectedQuantity) {
          this.selectedQuantity = Number(this.selectedQuantity) + 1
          this.isLimited = (this.maxQuantity === this.selectedQuantity)
        } else {
          this.isLimited = true
        }
      } else {
        if (this.selectedQuantity > 1) {
          this.selectedQuantity = Number(this.selectedQuantity) - 1
          this.isLimited = false
        }
      }
      this.calcTotalPrice()
    },
    /**
     * @description 해당메뉴 장바구니에 담기
     * @param {object} menu
     * @returns {void}
     */
    addSelectedMenu (menu) {
      let unsuitableCnt = 0
      this.optionGroupList.forEach(group => {
        if (group.isRequired) {
          if (group.selectedCnt !== group.selectableCount) {
            unsuitableCnt++
          }
        }
      })
      if (unsuitableCnt > 0) {
        this.alertMsg = this.$tc('requiredOption')
        this.showAlert = true
        return
      }
      if (this.useOnePersonOneMenuOrder && menu.isMain && (Number(this.remainMainMenuCnt) - Number(this.selectedQuantity) < 0)) {
        this.alertMsg = this.$tc('maximumQuantityOfMainMenu')
        this.showAlert = true
        return
      }
      // if (this.isModifing) {
      //   if (this.useOnePersonOneMenuOrder && menu.isMain) {}
      // } else {
      //   if (this.useOnePersonOneMenuOrder && menu.isMain && (Number(this.remainMainMenuCnt) - Number(this.selectedQuantity) < 0)) {
      //     this.alertMsg = this.$tc('maximumQuantityOfMainMenu')
      //     this.showAlert = true
      //     return
      //   }
      //   if (this.menuInfo.restrictionType !== 'NO_LIMIT') {
      //     console.log('selectedMenuList---', this.selectedMenuList)
      //   }
      // }
      const isModified = this.isModifing
      const { _id, name, isMain, isSoldOut } = menu
      const selectedMenu = { _id, name, isMain, isSoldOut }
      selectedMenu.options = Array.from(this.selectedOptions.options.values()).sort((pre, next) => {
        if (pre._id > next._id) return 1
        if (pre._id < next._id) return -1
        return 0
      })
      selectedMenu.size = this.selectedOptions.size
      selectedMenu.quantity = this.selectedQuantity
      selectedMenu.price = this.calcPrice()
      this.$emit('addSelectedMenu', selectedMenu, isModified)
      this.closePopup()
    },
    /**
     * @description 라디오(필수 + 단일 선택) 옵션 그룹 여부
     * @param {object} optionGroup
     * @returns {boolean}
     */
    isRadioGroup (optionGroup) {
      return optionGroup.selectableCount === 1 && optionGroup.isRequired
    },
    /**
     * @description 수량 선택 가능한 옵션 여부 (체크박스 그룹 + 그룹/옵션 모두 선택 가능 수량 2개 이상)
     * @param {object} optionGroup
     * @param {object} option
     * @returns {boolean}
     */
    isQtyOption (optionGroup, option) {
      // 매장의 옵션 수량 설정(useMenuOptionQuantity)이 ON인 경우에만 수량 스템퍼 노출
      return this.useMenuOptionQuantity && !option.isSoldOut && !this.isRadioGroup(optionGroup) && optionGroup.selectableCount > 1 && option.selectableCount > 1
    },
    /**
     * @description 해당 옵션이 선택 가능한 최대 수량 (옵션 자체 한도와 그룹 잔여 한도 중 작은 값)
     * @param {object} optionGroup
     * @param {object} option
     * @returns {number}
     */
    optionMaxQty (optionGroup, option) {
      const otherQty = optionGroup.selectedCnt - (option.quantity || 0)
      const groupRemain = optionGroup.selectableCount - otherQty
      return Math.min(option.selectableCount || 1, groupRemain)
    },
    /**
     * @description 옵션 그룹의 선택 수량/비활성화 상태 재계산
     * @param {object} optionGroup
     * @param {number} selectedCnt
     * @returns {void}
     */
    applyGroupState (optionGroup, selectedCnt) {
      this.optionGroupList = this.optionGroupList.map((group) => {
        if (group._id === optionGroup._id) {
          group.selectedCnt = selectedCnt
          group.options = group.options.map((option) => {
            option.isDisabled = (selectedCnt >= group.selectableCount && !option.isSelected)
            return option
          })
        }
        return group
      })
    },
    /**
     * @description 옵션 수량 증감
     * @param {object} optionGroup
     * @param {object} option
     * @param {boolean} isPlus
     * @returns {void}
     */
    changeOptionQuantity (optionGroup, option, isPlus) {
      const { _id, name, price } = option
      let selectedCnt = optionGroup.selectedCnt
      if (isPlus) {
        const newQty = option.quantity + 1
        const groupRemain = optionGroup.selectableCount - (selectedCnt - option.quantity)
        // 옵션 그룹 최대 수량 초과
        if (newQty > groupRemain) {
          this.alertMsg = this.$tc('reachedSelectableOptionGroupCount', optionGroup.selectableCount, { name: optionGroup.name, n: optionGroup.selectableCount })
          this.showAlert = true
          return
        }
        // 옵션 항목별 최대 수량 초과
        if (newQty > option.selectableCount) {
          this.alertMsg = this.$tc('reachedSelectableOptionCount', option.selectableCount, { name: option.name, n: option.selectableCount })
          this.showAlert = true
          return
        }
        option.quantity = newQty
        option.isSelected = true
        selectedCnt += 1
        this.selectedOptions.options.set(_id, { name, price, _id, quantity: option.quantity })
      } else {
        if (option.quantity <= 0) { return }
        option.quantity -= 1
        selectedCnt -= 1
        if (option.quantity <= 0) {
          option.isSelected = false
          this.selectedOptions.options.delete(_id)
        } else {
          this.selectedOptions.options.set(_id, { name, price, _id, quantity: option.quantity })
        }
      }
      this.applyGroupState(optionGroup, selectedCnt)
      this.calcTotalPrice()
    },
    multiSelectOptionChange (optionGroup, selectedOption) {
      let selectedCnt = optionGroup.selectedCnt
      const { _id, name, price } = selectedOption
      if (selectedOption.isSelected) {
        // 선택 해제: 선택 수량 전체 차감
        if (this.selectedOptions.options.has(_id)) {
          this.selectedOptions.options.delete(_id)
          selectedCnt -= (selectedOption.quantity || 1)
        }
        selectedOption.quantity = 0
        selectedOption.isSelected = false
      } else {
        // 선택: 그룹 잔여 수량이 있으면 1개 추가, 없으면 안내 문구 노출
        if (selectedCnt < optionGroup.selectableCount) {
          selectedOption.quantity = 1
          selectedOption.isSelected = true
          this.selectedOptions.options.set(_id, { name, price, _id, quantity: 1 })
          selectedCnt += 1
        } else {
          this.alertMsg = this.$tc('reachedSelectableOptionGroupCount', optionGroup.selectableCount, { name: optionGroup.name, n: optionGroup.selectableCount })
          this.showAlert = true
          return
        }
      }
      this.applyGroupState(optionGroup, selectedCnt)
      this.calcTotalPrice()
    },
    singleSelectOptionChange (optionGroup, selectedOption) {
      const tempOptionGroupList = this.optionGroupList.map((group) => {
        if (group._id === optionGroup._id) {
          group.options = group.options.map((option) => {
            const { _id, name, price } = option
            if (_id === selectedOption._id) {
              option.isSelected = true
              option.quantity = 1
              this.selectedOptions.options.set(_id, { name, price, _id, quantity: 1 })
            } else {
              option.isSelected = false
              option.quantity = 0
              if (this.selectedOptions.options.has(_id)) this.selectedOptions.options.delete(_id)
            }
            return option
          })
          group.selectedCnt = 1
        }
        return group
      })
      this.optionGroupList = tempOptionGroupList
      this.calcTotalPrice()
    },
    selectOption (optionGroup, selectedOption) {
      if (selectedOption.isSoldOut) { return }
      if (this.isRadioGroup(optionGroup)) {
        this.singleSelectOptionChange(optionGroup, selectedOption)
      } else {
        this.multiSelectOptionChange(optionGroup, selectedOption)
      }
    },
    changeSelectedSize (selectedSize) {
      this.sizesList = this.sizesList.map((size) => {
        size.isSelected = (size._id === selectedSize._id)
        return size
      })
      this.selectedOptions.size = selectedSize
      this.calcTotalPrice()
    },
    displayLimitCnt (option) {
      let str = ''
      if (option.isRequired) {
        str = (option.selectableCount > 1) ? `(${this.$tc('maxSelectableCount', option.selectableCount)})` : ''
      } else {
        str = (option.selectableCount === option.options.length) ? '' : `(${this.$tc('maxSelectableCount', option.selectableCount)})`
      }
      return str
    },
    displayPrice (price) {
      const displayPrice = (price === 0) ? price : price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      return this.$tc('menuMonetaryUnit', displayPrice)
    },
    /**
     * @description 옵션 가격 표기 (항상 + 표기, 숫자·단위 공백 없음)
     * @param {number} price
     * @returns {string} ex) +2,000원, +0원
     */
    displayOptionPrice (price) {
      const formatted = (price === 0) ? price : price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      return `+${this.$tc('won', formatted)}`
    },
    infoText (menu) {
      let str = ''
      if (menu.restrictionType === 'NO_LIMIT' && menu.leftQuantity <= this.outOfStockSetQuantity) {
        str = this.$tc('almostSoldOut', menu.leftQuantity)
      }
      if (menu.restrictionType === 'HALF') {
        str = this.$tc('halfOfPeople', menu.maxPermittedQuantity)
      }
      if (menu.restrictionType === 'CASE') {
        str = `주문 당 최대 ${menu.maxPermittedQuantity}개 주문 가능`
      }
      return str
    },
    closePopup () {
      this.$emit('closePopup')
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/base.scss";
.popup_wrap {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 999;
  background: rgba(0, 0, 0, 0.6);
  .popup {
    position: absolute;
    width: 94.375vw;
    height: 91vh;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    border-radius: 4vh;
    background: $white;
    .popup_content {
      display: flex;
      height: 78vh;
      word-break: break-all;
      .info_wrap {
        width: 19.6875vw;
        margin: 4vh 1.875vw 0;
        overflow-y: scroll;
        .tags {
          display: flex;
          height: 3vh;
          margin-bottom: 1vh;
          .tag {
            padding: 0.5vh;
            margin-right: 0.3125vw;
            font-size: 16px; // IE11 fallback
            font-size: unquote("min(1.25vw, 16px)");
            border-radius: 0.5vh;
            &.featured {
              background: $green_12;
              color: $green;
            }
            &.main {
              background: $deep_blue_6;
              color: $deep_blue;
            }
            &.limited {
              background: $orange_6;
              color: $orange;
            }
          }
        }
        .name {
          font-size: 32px; // IE11 fallback
          font-size: unquote("min(2.5vw, 32px)");
          font-weight: bold;
          color: $gray_900;
          margin-bottom: 2vh;
        }
        .description {
          font-size: 18px; // IE11 fallback
          font-size: unquote("min(1.40625vw, 18px)");
          color: $gray_800;
          line-height: 1.5;
          margin-top: 2vh;
        }
        .status {
          width: 100%;
          padding: 1vh;
          font-size: 18px; // IE11 fallback
          font-size: unquote("min(1.40625vw, 18px)");
          font-weight: bold;
          background: $orange_6;
          border-radius: 1vh;
          color: $orange;
        }
      }
      .option_wrap {
        background: $gray_50;
        overflow: hidden;
        .scroll-area {
          width: 42.5vw;
          margin: 4vh 2.5vw 0;
          overflow-y: scroll;
          height: 100%;
          box-sizing: border-box;
          padding-bottom: 10vh; // 하단 여백 80px (세로 짧은 해상도 대응)
        }
        .option {
          padding-top: 4vh;
          border-bottom: 0.125vh solid $e0;
          &:first-child {
            padding-top: 0;
          }
          &:last-child {
            border-bottom: none;
          }
          .option_title {
            display: flex;
            line-height: 1.5;
            margin-bottom: 3vh;
            .required, .title, .limitCnt {
              font-size: 24px; // IE11 fallback
              font-size: unquote("min(1.875vw, 24px)");
              font-weight: bold;
              color: $gray_900;
            }
            .required {
              flex-shrink: 0;
              margin-right: 0.3125vw;
              color: $orange;
            }
            .title {
              margin-right: 0.3125vw;
            }
            .limitCnt {
              flex-shrink: 0;
            }
          }
          .option_item {
            display: flex;
            align-items: center;
            width: 100%;
            margin-bottom: 3vh;
            &:last-child {
              margin-bottom: 4vh;
            }
            .icon {
              flex-shrink: 0;
              width: 2.8125vw;
              height: 2.8125vw;
              margin: 0 0.78125vw 0 0;
              &.radio {
                background: url("../assets/radio.svg") center / contain no-repeat;
                &.active {
                  background: url("../assets/radio_active.svg") center / contain no-repeat;
                }
              }
              &.checkbox {
                background: url("../assets/checkbox.svg") center / contain no-repeat;
                &.active {
                  background: url("../assets/checkbox_active.svg") center / contain no-repeat;
                }
              }
            }
            .name, .price {
              font-size: 20px; // IE11 fallback
              font-size: unquote("min(1.5625vw, 20px)");
              color: $gray_700;
              line-height: 1.5;
            }
            .price {
              min-width: 8.4375vw;
              margin-left: auto;
              text-align: right;
            }
            .option_count {
              display: flex;
              align-items: center;
              flex-shrink: 0;
              @include flex-gap(0.625vw, row); // 버튼-숫자 간격 8px
              .minus, .plus {
                flex-shrink: 0;
                width: 2.8125vw; // 36px
                height: 4.5vh; // 36px
                background-repeat: no-repeat;
                background-position: center;
                background-size: contain;
              }
              .minus {
                background-image: url("../assets/img/count-button/minus-on.png");
                &.disabled {
                  background-image: url("../assets/img/count-button/minus-off.png");
                }
              }
              .plus {
                background-image: url("../assets/img/count-button/plus-on.png");
                &.disabled {
                  background-image: url("../assets/img/count-button/plus-off.png");
                }
              }
              .count {
                min-width: 3.125vw; // 40px
                text-align: center;
                font-size: 20px; // IE11 fallback
                font-size: unquote("min(1.5625vw, 20px)");
                font-weight: 500;
                line-height: 4vh; // 32px
                color: $gray_700;
              }
            }
            &.has_count {
              .price {
                min-width: auto;
                margin-left: 0.78125vw;
                text-align: left;
              }
              .option_count {
                margin-left: auto;
              }
            }
            &.disabled {
              .name, .price {
                color: $gray_400;
              }
              .option_count {
                .minus {
                  background-image: url("../assets/img/count-button/minus-off.png");
                }
                .plus {
                  background-image: url("../assets/img/count-button/plus-off.png");
                }
                .count {
                  color: #b6c0cc;
                }
              }
            }
            &.soldout {
              .soldout_badge {
                flex-shrink: 0;
                margin-right: 0.625vw; // 뱃지-텍스트 간격 8px
                padding: 0.25vh 0.625vw; // 2px 8px
                border-radius: 0.75vh; // 6px
                background: rgba(216, 27, 27, 0.1);
                color: #d81b1b;
                font-size: 16px; // IE11 fallback
                font-size: unquote("min(1.25vw, 16px)");
                font-weight: 600; // SemiBold
                line-height: 3vh;
              }
              .name, .price {
                color: #b7bec8;
              }
              .price {
                min-width: auto;
                margin-left: 0.3125vw;
                text-align: left;
              }
            }
            &.selected {
              .icon {
                &.radio {
                  width: 2.8125vw;
                  height: 2.8125vw;
                  margin: 0 0.78125vw 0 0;
                  background: url("../assets/radio_active.svg") center / contain no-repeat;
                }
                &.checkbox {
                  width: 2.8125vw;
                  height: 2.8125vw;
                  margin: 0 0.78125vw 0 0;
                  background: url("../assets/checkbox_active.svg") center / contain no-repeat;
                }
              }
              .name, .price {
                font-weight: bold;
                color: $gray_900;
              }
            }
          }
        }
      }
      .select_option_wrap {
        position: relative;
        width: 23.4375vw;
        padding: 4vh 1.25vw 1.75vh;
        .option_list_wrap {
          padding: 0 0.625vw;
          margin: 0 0 2vh 0;
          height: calc(100% - 13.625vh - 2vh);
          .selected_option_title {
            font-size: 24px; // IE11 fallback
            font-size: unquote("min(1.875vw, 24px)");
            font-weight: bold;
            padding-bottom: 3vh;
          }
          .list_wrap {
            height: calc(100% - 2vh - 6.625vh);
            overflow-y: scroll;
          }
          .selected_option_list {
            width: 100%;
            .selected-option-item {
              display: flex;
              padding-bottom: 2vh;
              div {
                font-size: 18px; // IE11 fallback
                font-size: unquote("min(1.40625vw, 18px)");
                color: $gray_600;
              }
              .option_name {
                width: 12.03125vw;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .option_price {
                margin-left: auto;
              }
            }
          }
        }
        .count_button_wrap {
          // padding: 0 0 0 1.25vw;
          .button_title {
            font-size: 24px; // IE11 fallback
            font-size: unquote("min(1.875vw, 24px)");
            font-weight: bold;
            color: $gray_900;
            padding-bottom: 2vh;
          }
          .count_button {
            display: flex;
            .minus, .plus {
              flex-shrink: 0;
              width: 5vw;
              height: 8vh;
              background-repeat: no-repeat;
              background-position: center;
              background-size: contain;
            }
            .count {
              width: 100%;
              line-height: 8vh;
              font-size: 32px; // IE11 fallback
              font-size: unquote("min(2.5vw, 32px)");
              font-weight: 700;
              color: $gray_900;
              text-align: center;
            }
            .minus {
              background-image: url("../assets/img/menu-count/menu-minus-on.svg");
              margin-right: 0.625vw;
              &.disabled {
                background-image: url("../assets/img/menu-count/menu-minus-off.svg");
              }
            }
            .plus {
              background-image: url("../assets/img/menu-count/menu-plus-on.svg");
              margin-left: 0.625vw;
              &.disabled {
                background-image: url("../assets/img/menu-count/menu-plus-off.svg");
              }
            }
          }
        }
        .speech-bubble {
          background: url("../assets/cloud.svg") no-repeat;
          width: 19.921875vw;
          height: 11.5vh;
          position: absolute;
          top: 55vh;
          left: 1.796875vw;
          text-align: center;
          color: $danger;
          font-size: 18px; // IE11 fallback
          font-size: unquote("min(1.40625vw, 18px)");
          line-height: 0.25vh;
          padding-top: 3.75vh;
          filter: drop-shadow(0.25vh 0.5vh 1vh rgba(69, 19, 11, 0.15));
        }
      }
    }
    .button_wrap {
      display: flex;
      padding: 2vh 1.25vw;
      .button {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 9vh;
        padding: 3vh 0;
        font-size: 24px; // IE11 fallback
        font-size: unquote("min(1.875vw, 24px)");
        border-radius: 2vh;
        text-align: center;
      }
      .close_popup {
        width: 17.1875vw;
        margin-right: 1.25vw;
        border: 0.25vh solid $gray_900;
        color: $gray_900;
      }
      .save_option {
        width: 73.4375vw;
        background: $light_blue;
        font-weight: bold;
        color: $white;
      }
    }
  }
}
</style>
